export const validateConfig = (config) => {
  try {
    if (config.name === '' || config.rules.some(r => r.value === '')) {
      return false;
    }
  } catch (err) {
    return false;
  }
  return true;
}
